import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import MetaCatalogMgr from './components/MetaCatalogMgr';
import MetaProductSetsMgr from './components/MetaProductSetsMgr';

export default function MetaCatalogIndexPage() {
  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">Meta Catalog Manager</h3>
        </Col>
      </Row>
      <Row>
        <MetaCatalogMgr />
      </Row>
      <Row>
        <MetaProductSetsMgr />
      </Row>
    </Container>
  );
}
